import { Alert, Box } from '@mui/material';
import { EmbeddedOfferContentTab } from 'app/pages/ContentManagementPage/components/offerContent/OfferContentTab';

type OffersEntityPanelProps = {
  dealerId: string;
  allowedIds: string[];
};

export default function OffersEntityPanel({
  dealerId,
  allowedIds,
}: OffersEntityPanelProps) {
  if (!allowedIds.length) {
    return (
      <Alert severity="info" sx={{ borderRadius: 2 }}>
        No offer IDs were provided for this attention row.
      </Alert>
    );
  }

  if (!dealerId.trim()) {
    return (
      <Alert severity="info" sx={{ borderRadius: 2 }}>
        Select a dealer to view offers.
      </Alert>
    );
  }

  return (
    <Box sx={{ minHeight: 0, flex: 1, overflow: 'hidden' }}>
      <EmbeddedOfferContentTab embedded allowedRowIds={allowedIds} />
    </Box>
  );
}

